import CryptoJS from "crypto-js";
import JSEncrypt from "./jsencrypt.min.js";

class hlEncryption {
    constructor() {
        // 公钥枚举
        this.EncryptionKeys = {
            // 慧运力小程序
            "HYL-XCX": {
                dev: {
                    terminalCode: "HYL-XCX",
                    publicKey:
                        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCyIG0nPZE0SGs3tIcgPowLahCq6NFEwFxJUxWuAZgC4s8/8LVNUHHlDvWVwDm0H9C2FR6MBRpr6UVBjxYyBCPwntziIrmYdqdzYstwivTiT6TrybXaL9mfKzY6h70+YEpyGhffzb1iNmKq4yUxlQgx0d96ZYSESDvIGHriwL6WFQIDAQAB",
                    signSecret: "6582efd1e50413146a81f79f8cd10124",
                },
                test: {
                    terminalCode: "HYL-XCX",
                    publicKey:
                        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC//+9Wntd31s89Z1bStMDyu6rr+W6oQ3SMa4VImg+Zh2MFXbPiEHiamzmTBXzhpqkbTUv0hDdOYL14ZrRgGBj4t6YFQwvXNjdTgGarHEIH7kVwunHrC/mvnwXVsWCWTs7QfXL3/WbaVPGd4yMR126uJlwQxIG/lx73SuucxeT5DQIDAQAB",
                    signSecret: "8dec8569ad95fd096c689fcb6ffe0099",
                },
                pro: {
                    terminalCode: "HYL-XCX",
                    publicKey:
                        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCZAk9Q4azWzhVgvWP45x3LOFix+H+qiJHtOHWmTS+qe3UPsWrpQCXP61ChOo+PnMHc2KwrVE3SJBXLrCVc64GvdYnf7SerzCWq8zKt92h5Z5vUkJX1s1KR9FdWIt1yFaBtUV6ZIpdHvQyhtljZn78YFEEXvt5X/AqoA5owdkTtfwIDAQAB",
                    signSecret: "71171d7676d5c7bc42f2221d7d721465",
                },
            },
            // 慧充电小程序
            "GIL-CHARGE-XCX": {
                dev: {
                    terminalCode: "GIL-CHARGE-XCX",
                    publicKey:
                        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC+HyjCrOjOnJ2BU53ZgObKslM1dhnMM8iM/ccpIqOtPq+KHvdj0ylrXYZQJQ0l+1IaC4MzwnwwNfk4n/kD/etD/ZtnZtqWisCQlK314dSCtll5uRWf+4RVJpE/rDjVoydKNBqGYHPxHtV60Qhcbq3z82wmYwmkeKFux1r3yzq10wIDAQAB",
                    signSecret: "cd69fadb68da8dd8779e1c8d7f2917c6",
                },
                test: {
                    terminalCode: "GIL-CHARGE-XCX",
                    publicKey:
                        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDWDoA6GAKhPgSEI56Xb9AtaVsM8DYGpMLAf6WS3C18FpiQ7teGM7/cNbrKBdwZV0wfrtb+ODWFWysXxMJyj3YaC32LBuqwgXf7eq7ELapLIZOdkHVuPqgYIainEi/ahavZz5Or7l1McuWnWboY1SVbpBN15GiWNB3hAal/EQeOVwIDAQAB",
                    signSecret: "21e40b8baf8cc30d474b456fdfb71b29",
                },
                pro: {
                    terminalCode: "GIL-CHARGE-XCX",
                    publicKey:
                        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCEFvmLlrlTPh1Au+++qSbW61lQY++u0YzGkE12u5lz0ZKuWODkYfPC1sC9QcXYCk2DXUTamjpk4RgXdB3JT7r1c4JFw9RySimL78wDs/zfL2AsNa1DPAztQcgcLGqQWaIMEig4OT2Gec58jlN+u2+1GYEO4zqALoMmb93i+287qwIDAQAB",
                    signSecret: "58d712baf06abf7b663d1dc00a2a8db3",
                },
            },
            // 远程慧联小程序
            "GIL-APP-XCX": {
                dev: {
                    terminalCode: "GIL-APP-XCX",
                    publicKey:
                        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC0TvLMWG7x/cH3UH99y4ZuNg8o4wn8N3uUBd9w2K1SypmHHwIE3/rcjwumgiwUI2Meh2/ct8tahMzHPKCH5Aql2flYEan0mzzJaiv03CqaF05OmyiNiT/MAsPr7lLXSICsnuuXkdtxzDpRA37AtbQthj4FBnN+AgebEkNqQfnx5QIDAQAB",
                    signSecret: "fbcd521b5cbc5e14490f7c4a7bcb09ff",
                },
                test: {
                    terminalCode: "GIL-APP-XCX",
                    publicKey:
                        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC4m7IooFkKr1lex05g1kVK2ukRlk6JMZgdkITi5s4n1IkOASTObt3zG2FTpRU0uQ/16M3Hs8yk9mA82DGLVuuknCbJ3srpuDgTGmu1DIR/LTLXI2MNCpaEcyq0f5HQIFnuVQM9vtmZ8mmNG+KHtVc3s8/oTuIDisxi9TvLH0d+PQIDAQAB",
                    signSecret: "cce60ce78ddcb74c4a99d7b5a1167f85",
                },
                pro: {
                    terminalCode: "GIL-APP-XCX",
                    publicKey:
                        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCzdDMV8gIsg+VneK6sRlBbUv5ewkcoQN4G3v+lc502GZLXJu550mh60oYUEiOQ3GeeDxZRr7fvuToJi08VGiqbgc1WV6s3cwDI8E39UI5yEGUqRhgjMlQV45CJwFY6sbz42fBVOu0rVmffEuHpiTJ6NJ6tLb0OznO3rbQt5NwEmwIDAQAB",
                    signSecret: "cf715a429c94a143e1a5cb91e95afe13",
                },
            },
            // 供应商小程序
            "WECHART-XCX": {
                dev: {
                    terminalCode: "WECHART-XCX",
                    publicKey:
                        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQClGIKu88ld/r8YL2Spv0LjVGBsamWIsq1lG18DXEr4yZmMoS6wqo7d5Ei1SQj/S1Imk3hZiDlUagDUzsfzmn0SK31IhZn7NqXVQb0jUCIhMielxcP9YdOa5bSsy0lCvXpWHnVNggTGgpdWELFOVTimhLcCnJGfRtkpFpUCdDda6QIDAQAB",
                    signSecret: "f9a73571551dbc48fe1984462cc89e86",
                },
                test: {
                    terminalCode: "WECHART-XCX",
                    publicKey:
                        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC184xSuIAZZgYDxzu/Rmq/y7SxgB0f5q54cgX91qWyy5Bpfug4sGsqwWRE5ajxrEQfdbOTIkbrjTb1ghFnQMDX5Eomi/B9RsVRVk6WIhbexdsO6Ro/w63bDaQoycgoYu1dbQEF7ZR1+Ap28W44WHdiQOsMf3iOGHtz7EFXBIIw/wIDAQAB",
                    signSecret: "fadecfee9afc270152ac1f1171a770e2",
                },
                pro: {
                    terminalCode: "WECHART-XCX",
                    publicKey:
                        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCIgmUJYRDaFJ72A7Bj52x2bX4ebnT8cwQcogBDPc3Wm5SA5ilHDInHd6sg+GAw+2Nc/sZ0BcmuPAd18mqexEo7YyqyUTm5t5KMb/iPpVC68k9f0N732AIN6KGSbXsZWJkYakv8jDdzT115RiQkyXG7nA8GGmPetkesOcqCFZanDQIDAQAB",
                    signSecret: "d5a246fb234a8df3b771b81fffed8a9e",
                },
            },
            // 远程慧联-H5
            "GIL-APP-H5": {
                dev: {
                    terminalCode: "GIL-APP-H5",
                    publicKey:
                        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCKKK6p6clGIMwzHA+d2dmblZfiG7e9ODtaG5Vcpn5enz3NeEppUPvroj7QXz//iRdUqbpzl8ugLd7iToBVlBf2C7ym+cOXgV0wHNz+q/GKln6f0XrkDnkKe74oY/Xr0T5s5zASgSNDb314YMb6inwIYTH79LfkEz0H/MyZipR18wIDAQAB",
                    signSecret: "e12177281bf1d3600ca326de0344b886",
                },
                test: {
                    terminalCode: "GIL-APP-H5",
                    publicKey:
                        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDYGwSLVpMqdmtqSBMHl8T2H6rBUD7Q197+F0hXOyDKpn9Di85RHwD8Mroy0Y1A953g4kLXS3STYxVtFfs3/yabL4j8QreTSf1LtFDOFoY+zP4OLm3UEHMSKnuDZvA6PU8ja6cAschtmcTDEt8lR98L9QUVuQcs+Go/xygyq1sW/QIDAQAB",
                    signSecret: "5d42e7d5f94539766bae13e0ba1d3405",
                },
                pro: {
                    terminalCode: "GIL-APP-H5",
                    publicKey:
                        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCPQ1ZHFWod5pMGzHHVxUYvBnhXeSnYE/GcKuz70Qb1fA5ztMJhmQuP/8sLhj6fnFhf6qiSIbuHknhhwg9NvQUyhWXLeLHKQf/3MSwkWZT+eNsXaIbF4p4azuPjYvbMy1Xt9D590qsyiqBeE92AFfklJf/3SKJejgB5KicE7ohNUwIDAQAB",
                    signSecret: "4a019b017f9fb51abfd63a832418292f",
                },
            },
            // 车小慧-H5
            "HIC-H5": {
                dev: {
                    terminalCode: "HIC-H5",
                    publicKey:
                        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCXAgHPZ8Ds0bdLDYsNIjsYeW90AkUeiSMpYPX2srXwjOgsDcSRl9PM6M/r27WVeKo0S5D17UF3qqHdyetIZL6megw/2G9Qc7RNJ6bSvlyFGE1CgRr6lUfYM3LvK4FIUc5HJBnxBoMb34AwHgs2+p1qJQLvfho6xZknOXGXJSvBtQIDAQAB",
                    signSecret: "373d670ae40a610a7f6cfd8dced02af7",
                },
                test: {
                    terminalCode: "HIC-H5",
                    publicKey:
                        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCRK4FTU1yJxVZZvC5xGCoTeFVK+LuUwRyV0lZlXW1+cY+CAe4vh4G4/5OVi/qjbA0iClczTagXgHOhNRnqBaqbVFm0qtLbFGYALmB/loIRCwJl9Ivzg5suUmjtj6J70ucDeOeo+c7q4izLGFCsjC9+VddCUffOt5K6B27reI79VwIDAQAB",
                    signSecret: "13bae43915fa433bbcda6ba9e97c9632",
                },
                pro: {
                    terminalCode: "HIC-H5",
                    publicKey:
                        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDF3TWLEg8fj6/wd8szQvZShQ0JBmbVGaan4dfQm/cF/j6f/9G3/3Xft5Gie/+vC9LCb+Yl19jzhhTBvonRt8SqOwQtRw4zRXQVEjZTMyuDaV5D4L4yDo2e5ObsYi+RlV1kxL3K+Qi+n9LP9KgSF0Guf9iRWNeLrlUTuNdj1/Zk6QIDAQAB",
                    signSecret: "a1bc476faffd5159dfdad0db54bcd741",
                },
            },
        };
        this.terminalCode = this.getUrlParam("terminalCode");
        this.viewPortData = this.viewPort();
        this.encryptionParamer = this.initEncryptionParamer();
        this.hicClientSecret = "";
    }

    viewPort() {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin:
                u.indexOf("micromessenger") > -1 ||
                u.match(/weixin*/i) ||
                u.match(/wechat*/i),
            isQQ: u.indexOf("qq/") > -1,
            trident: u.indexOf("trident") > -1, //IE内核
            presto: u.indexOf("presto") > -1, //opera内核
            webKit: u.indexOf("applewebkit") > -1, //苹果、谷歌内核
            gecko: u.indexOf("gecko") > -1 && u.indexOf("khtml") == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) || !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf("android") > -1 || u.indexOf("linux") > -1, //android终端或者uc浏览器
            iPhone: u.indexOf("iphone") > -1 || u.indexOf("mac") > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf("ipad") > -1, //是否iPad
            webApp: u.indexOf("safari") == -1, //是否web应该程序，没有头部与底部
            huilianApp: u.indexOf("huilianapp") > -1, //是否慧联系的app
        };
    }
    getUrlParam(paraName) {
        let url = document.location.toString();
        if (url.indexOf("#/") >= 0) {
            url = url.split("#/");
        } else {
            url = [url];
        }
        let attrs = [];
        url.map(function (item) {
            if (item.indexOf("?") >= 0) {
                attrs.push(item.split("?")[1]);
            }
        });
        attrs = attrs.join("&");
        const arrPara = attrs.split("&");
        let arr;
        for (let i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split("=");
            if (arr != null && arr[0] == paraName) {
                return decodeURIComponent(arr[1]);
            }
        }

        return "";
    }
    initEncryptionParamer() {
        let encryptionParamer = {
            terminalCode: "",
            publicKey: "",
            signSecret: "",
        };
        const viewPortData = this.viewPort();
        if (this.terminalCode) {
            encryptionParamer = this.getTerminalCode(this.terminalCode);
        } else {
            if (viewPortData.huilianApp) {
                if (
                    viewPortData.ios ||
                    viewPortData.iPhone ||
                    viewPortData.iPad
                ) {
                    if (window.webkit) {
                        encryptionParamer.terminalCode = window.prompt(
                            "getTerminalCode",
                            ""
                        );
                        encryptionParamer.publicKey = window.prompt(
                            "getPublicKey",
                            ""
                        );
                        encryptionParamer.signSecret = window.prompt(
                            "getSignSecret",
                            ""
                        );
                    }
                } else if (window.huilian && window.huilian.getTerminalCode) {
                    encryptionParamer.terminalCode =
                        window.huilian.getTerminalCode();
                    encryptionParamer.publicKey = window.huilian.getPublicKey();
                    encryptionParamer.signSecret =
                        window.huilian.getSignSecret();
                }
            }
            if (!encryptionParamer.terminalCode) {
                encryptionParamer = this.getTerminalCode("GIL-APP-H5");
            }
        }
        localStorage.setItem(
            "EncryptionParame",
            JSON.stringify(encryptionParamer)
        );
        return encryptionParamer;
    }

    getTerminalCode(terminalCode) {
        let type = "dev";
        if (process.env.NODE_ENV === "development") {
            const packageJson = require("../../../package.json");
            if (packageJson.proxy["/gateway"].target.indexOf("test.") > -1) {
                type = "test";
            } else {
                type = "dev";
            }
        } else {
            const host = window.location.host;
            if (
                host.indexOf("hellogil.com") > -1 ||
                host.indexOf("pre.") > -1 ||
                host.indexOf("www.") > -1
            ) {
                type = "pro";
            } else if (host.indexOf("test.lvsehuilian.cn") > -1) {
                type = "test";
            } else {
                type = "dev";
            }
        }
        // console.log(terminalCode, type);
        return this.EncryptionKeys[terminalCode][type];
    }

    getClientSecret(callback = () => {}) {
        const encryptor = new JSEncrypt();
        encryptor.setPublicKey(this.encryptionParamer.publicKey);
        const clientKey = encryptor.encrypt(
            this.encryptionParamer.terminalCode
        );
        fetch("/gateway/huilianCust/hcClientcs/efficacyClient", {
            method: "POST",
            headers: {
                //   'Content-Type': 'application/json',
                "Content-Type":
                    "application/x-www-form-urlencoded;charset=UTF-8",
                terminalCode: this.encryptionParamer.terminalCode,
                nonce: this.generateNonce(),
                timestamp: this.formatTime(new Date()),
            },
            body: `terminalCode=${
                this.encryptionParamer.terminalCode
            }&clientKey=${encodeURIComponent(clientKey)}`,
        })
            .then((response) => response.json())
            .then((res) => {
                let hicClientSecret = "";
                if (res.result === "success" && res.data) {
                    if (res.data.clientSecret && res.data.clientSwitch == 1) {
                        hicClientSecret = encryptor.decrypt(
                            res.data.clientSecret
                        );
                        localStorage.setItem(
                            "hicClientSecret",
                            hicClientSecret
                        );
                    } else {
                        localStorage.removeItem("hicClientSecret");
                    }
                }
                this.hicClientSecret = hicClientSecret;
                callback();
            })
            .catch((error) => {
                this.hicClientSecret = "";
                callback();
                console.error("Error:", error);
            });
    }

    setRequestHeaders(data) {
        if (this.encryptionParamer) {
            data.headers.terminalCode = this.encryptionParamer.terminalCode;
            data.headers.nonce = this.generateNonce();
            data.headers.timestamp = this.formatTime(new Date());
            let hicClientSecret =
                this.hicClientSecret || localStorage.getItem("hicClientSecret");

            if (hicClientSecret && hicClientSecret !== "false") {
                data.headers.sign = this.formSign(data.url, data.headers.nonce);
            }
        }
        return data.headers;
    }

    generateNonce() {
        return Math.floor(
            (Math.random() + Math.floor(Math.random() * 9 + 1)) *
                Math.pow(10, 9)
        );
    }

    formatNumber(n) {
        n = n.toString();
        return n[1] ? n : "0" + n;
    }
    formatTime(date) {
        try {
            // 使用 Intl.DateTimeFormat 并指定中国时区
            return new Intl.DateTimeFormat("zh-CN", {
                timeZone: "Asia/Shanghai",
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
            })
                .format(date)
                .replace(/\//g, "-");
        } catch (e) {
            // 如果浏览器不支持 timeZone 选项，则回退到手动计算
            const chinaDate = new Date(date);
            const year = chinaDate.getFullYear();
            const month = chinaDate.getMonth() + 1;
            const day = chinaDate.getDate();
            const utcHour = chinaDate.getUTCHours();
            const chinaHour = (utcHour + 8) % 24;
            const minute = chinaDate.getMinutes();
            const second = chinaDate.getSeconds();

            return (
                [year, month, day].map(this.formatNumber).join("-") +
                " " +
                [chinaHour, minute, second].map(this.formatNumber).join(":")
            );
        }
    }

    substr(originalStr, mod4) {
        let strToAppend = "====".slice(0, mod4);
        return originalStr.concat(strToAppend);
    }

    AESDecrypt(val = "") {
        let key = CryptoJS.enc.Utf8.parse(this.hicClientSecret);
        let data = val.replace(/-/g, "+").replace(/_/g, "/");
        let mod4 = data.length % 4;
        if (mod4) {
            data = this.substr(data, mod4);
        }
        let encryptedData = CryptoJS.AES.decrypt(data, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7,
        });
        return encryptedData.toString(CryptoJS.enc.Utf8);
    }

    formSign(url, nonce) {
        const sign = this.encryptionParamer.signSecret;
        let hicClientSecret =
            this.hicClientSecret || localStorage.getItem("hicClientSecret");
        const inputData = sign + url + nonce;
        // console.log(inputData)
        let key = CryptoJS.enc.Utf8.parse(hicClientSecret);
        let encryptedData = CryptoJS.AES.encrypt(inputData, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7,
        });
        return encryptedData.toString();
    }
    decryptResponse(headers, res) {
        let resultData = res.data;
        if (headers.clientswitch == 1) {
            if (typeof res.data === "string") {
                const resData = this.AESDecrypt(res.data);
                try {
                    resultData = JSON.parse(resData);
                } catch (err) {
                    resultData = resData;
                }
                return resultData;
            }
            return resultData;
        }
        return resultData;
    }
}

export default hlEncryption;



// WEBPACK FOOTER //
// ./src/utils/jsencrypt/hlEncryption.js